import useLogAnalyticsOnFirebaseAuthChange from "services/firebase/auth/analytics/useLogAnalyticsOnFirebaseAuthChange";

import useRedirectOnAuthStateChanged from "features/app/redirect-on-auth-state-changed/useRedirectOnAuthStateChanged";
import useRedirectToConnectMicrosoftAccountModal from "features/sign-up/components/ConnectMicrosoftAccountModal/hooks/useRedirectToConnectMicrosoftAccountModal";

import useAuthWithCustomToken from "../../user-impersonation/useAuthWithCustomToken";
import useUpdateUserLastVisit from "./useUpdateUserLastVisit";

export default function AuthListeners({
  initialized
}: {
  initialized: boolean;
}) {
  useAuthWithCustomToken();
  useUpdateUserLastVisit({ initialized });
  useLogAnalyticsOnFirebaseAuthChange();
  useRedirectOnAuthStateChanged();
  useRedirectToConnectMicrosoftAccountModal();
  return null;
}
